'use client';

import { useState } from 'react';
import { toast } from 'sonner';

type SyncResult = { ok: boolean; totalItems?: number; bucket?: string; error?: string };

export function useAwardsSync() {
  const [isLoading, setIsLoading] = useState(false);

  const syncAwards = async () => {
    // Ask for the admin token (so we don't hardcode it client-side)
    const token = window.prompt('Enter admin token to sync Awards/Recognitions:', '');
    if (!token) return;

    setIsLoading(true);
    try {
      const res = await fetch('/api/awards-sync', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-admin-token': token,
        },
        body: JSON.stringify({}),
      });

      const data = (await res.json()) as SyncResult;

      if (!res.ok || !data.ok) {
        const m = data?.error || `HTTP ${res.status}`;
        toast.error(`Awards sync failed: ${m}`);
        throw new Error(m);
      }

      // Success UI + "last synced" stamp used by the Footer
      const stamp = new Date().toLocaleString();
      localStorage.setItem('awards:lastSync', stamp);
      toast.success(
        `Awards synced${data.totalItems != null ? ` (${data.totalItems} categories)` : ''}.`
      );
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  return { syncAwards, isLoading };
}
